import { MtModule } from "server/models"
import { ActiveInactive, OrderType } from "client/utils"


export interface ModuleProps {
    moduleId: number
}

export type ModuleValidation = { [key in keyof MtModule]?: string}

export interface ModuleList { [moduleId: number]: MtModule }
export interface ModuleFilters {
    status?: ActiveInactive
    search?: string
}
export interface ModuleState {
    moduleList: ModuleList
    moduleIds: readonly number[]
    moduleView: MtModule
    moduleEdit: MtModule

    sortColumn: keyof MtModule
    sortOrder: OrderType
    filters: ModuleFilters

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean
}

export const MODULE_LIST = "MODULE_LIST"
export const MODULE_IDS = "MODULE_IDS"
export const MODULE_VIEW = "MODULE_VIEW"
export const MODULE_EDIT = "MODULE_EDIT"

export const MODULE_SORT = "MODULE_SORT"
export const MODULE_FILTERS = "MODULE_FILTERS"

export const MODULE_RELOAD_LIST = "MODULE_RELOAD_LIST"
export const MODULE_RELOAD_VIEW = "MODULE_RELOAD_VIEW"
export const MODULE_RELOAD_EDIT = "MODULE_RELOAD_EDIT"
